<template>
  <b-modal hide-footer :title="title" :ref="mid" content-class="rounded-0">
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      required: true
    },
    mid: {
      type: String,
      required: true
    }
  },
  methods: {
    openModal: function () {
      this.$refs[this.mid].show()
    },

    hideModal: function () {
      this.$refs[this.mid].hide()
    }
  }
}
</script>

<style lang="css" scoped>
.my-modal {
  border-radius: 0px;
  box-shadow: 0 5px 15px rgba(0,0,0,.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue